import { Component, ViewChild } from '@angular/core';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-expense-policy',
  standalone: true,
  imports: [CommonModule,RouterOutlet,RouterModule,DataTablesModule,LoaderComponent],
  templateUrl: './expense-policy.component.html',
  styleUrl: './expense-policy.component.scss'
})
export class ExpensePolicyComponent {
  isDisabled: boolean = false;
  ExpenseData :  any[] = [];
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  
  dtoptions: DataTables.Settings = {};
  constructor(
    private expense: ExpenseService,
    protected common: CommonService,
    private tooltip : TooltipService,
    private download : DownloadSampleService,
    private toast :  ToastService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_ExpenseRule_LoadUpdate();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_ExpenseRule_LoadUpdate() {
    this.isDisabled = true;
    this.expense.ESS_ExpenseRule_LoadUpdate({ SelectType: 1, ESS_ExpenseRuleId: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.TableDatas.forEach((element:any) => {
          element.WebESSApplicability = response.Table3.filter((e:any) => e.WebESSApplicabilityId == element.WebESSApplicabilityId)[0].ApplicabilityName
        });
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'ExpensePolicyMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.ExpenseData = data;
        if( this.ExpenseData.length > 0){
          this.download.exportToExcel(this.ExpenseData, "ExpensePolicies_data");
          this.isDisabled = false
        }
        else{
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }     
      });
  }
} 
